import { ToastAndroid } from "react-native"
import AsyncStorage from '@react-native-async-storage/async-storage';
import NetInfo from '@react-native-community/netinfo';
import config from '../constants/Config';
import { AnalyticsService } from "../constants/Analytics";

const analytics = new AnalyticsService();

class HttpRequest {
  private token: string = ''
  protected GET_BASE_URL = async function () {
    let saved_url: any = await AsyncStorage.getItem('api_base_url');

    if (saved_url) {
      if (config.base_urls.includes(saved_url)) {
        return saved_url
      }
    }

    saved_url = await this.GET_ACTIVE_BASE_URL()
    return saved_url;
  }

  protected GET_ACTIVE_BASE_URL = async function () {
    let requests = []
    config.base_urls.map(url => {
      let single_request = fetch(url, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        redirect: 'follow',
        referrerPolicy: 'no-referrer'
      });

      requests.push(single_request);
    })

    return new Promise((resolve, reject) => {
      let index = 0
      function iterator() {
        if (requests.length) {
          requests[index]
            .then(response => response.json())
            .then(response => {
              if (response?.code === 400 || response?.code === 200) {
                AsyncStorage.setItem('api_base_url', config.base_urls[index])
                resolve(config.base_urls[index])
              } else {
                index = index + 1
                if (index < requests.length) {
                  iterator();
                } else {
                  resolve(config.base_urls[0])
                }
              }
            })
            .catch(error => {
              index = index + 1
              if (index < requests.length) {
                iterator();
              } else {
                resolve(config.base_urls[0])
              }
            })
        } else {
          resolve(config.base_urls[0])
        }
      }

      iterator();
    });
  }

  protected async ApiRequest(
    method: 'GET' | 'POST',
    uri: string,
    data?: any,
    session_token?: string,
    external?: boolean,
    options?: Object,
    attempt?: number,
  ): Promise<any> {
    // let {uri, data, session_token, external, options, attempt, method} = params
    uri = uri ? uri : ""
    data = data ? data : null

    let url = await this.GET_BASE_URL() + '/' + uri
    if (external) {
      url = uri
    }
    let headers = {}
    if (session_token) {
      headers['user_session_token'] = session_token
    } else {
      let _token = await AsyncStorage.getItem('userToken');
      if (_token) {
        session_token = _token
        headers['user_session_token'] = session_token
      }
    }

    // api_call is a promise
    const api_call = new Promise((resolve, reject) => {
      fetch(url, {
        method: method,
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers,
        redirect: "follow",
        referrerPolicy: "no-referrer",
        body: data,
        ...options
      })
        .then((response: any) => {
          if (response.status === 200) {
            try {
              resolve(response.json())
            } catch (e) {
              analytics.logError(e)
              AsyncStorage.removeItem('api_base_url')
              this.ApiRequest(method, uri, data, session_token, external, options, attempt + 1)
                .then(retry_response => resolve(retry_response))
                .catch(retry_error => reject(retry_error))
            }
          } else {
            analytics.logErrorMessage(`api request status: ${response.status} | base_url: ${url} | uri: ${uri}`)
            if (attempt < config.max_api_call) {
              AsyncStorage.removeItem('api_base_url')
              this.ApiRequest(method, uri, data, session_token, external, options, attempt + 1)
                .then(retry_response => resolve(retry_response))
                .catch(retry_error => reject(retry_error))
            } else {
              // ToastAndroid.show('Something went wrong. Try again.', ToastAndroid.SHORT, ToastAndroid.BOTTOM)
              reject(response)
            }
          }
        })
        .catch(e => {
          analytics.logError(e)
          if (attempt < config.max_api_call) {
            //
            NetInfo.fetch().then(state => {
              if (!state.isInternetReachable) {
                reject(new Error('Internet not reachable'))
              } else {
                AsyncStorage.removeItem('api_base_url')
                this.ApiRequest(method, uri, data, session_token, external, options, attempt + 1)
                  .then(retry_response => resolve(retry_response))
                  .catch(retry_error => reject(retry_error))
              }
            });
          } else {
            // ToastAndroid.show('Service unavailble.', ToastAndroid.SHORT, ToastAndroid.BOTTOM)
            reject(e)
          }
        })
    })
    return await api_call;
  }

  /**
   * Sends a GET request
   * @param uri A string in this format: model/action
   * @param data Post data
   * @param session_token Session token
   * @param external Specify if request is pointing towards external domain
   * @param options Request header options
   * @param attempt n-th time of attempting request
   */
  get(
    uri: string,
    data?: any,
    session_token?: string,
    external?: boolean,
    options?: Object,
    attempt?: number
  ) {
    return this.ApiRequest('GET', uri, data, session_token, external, options, attempt)
  }

  /**
   * Sends a POST request
   * @param uri A string in this format: model/action
   * @param data Post data
   * @param session_token Session token
   * @param external Specify if request is pointing towards external domain
   * @param options Request header options
   * @param attempt n-th time of attempting request
   */
  post(
    uri: string,
    data?: any,
    session_token?: string,
    external?: boolean,
    options?: Object,
    attempt?: number
  ) {
    return this.ApiRequest('POST', uri, data, session_token, external, options, attempt)
  }

  setToken(_token: string) {
    this.token = _token
  }
}

export const http = new HttpRequest();

export const setToken = http.setToken

export default http

